import React from "react";
import styled from 'styled-components';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import WarningIcon from '../../../../../../components/icons/WarningIcon';
import CancelIcon from '../../../../../../components/icons/CancelIcon';
import TypographyTitle from '../../../../../../components/TypographyTitle';
import TypographyParagraph from '../../../../../../components/TypographyParagraph';
import Button from '../../../../../../components/Button';

export const DeleteDialog = styled((props) => <Dialog {...props}/>)`
  .MuiDialog-paper {
    width: 506px;
  }
`

export const TitleContainer = styled.div`
  padding: 30px 8px 12px 12px;
  display: flex;
  color: ${red[400]};
  margin: 3px 16px 0px 8px;
`

export const RedWarningIcon = styled((props) => <WarningIcon {...props}/>)`
  font-size: 37px;
`

export const Title = styled((props) => <TypographyTitle {...props}/>)`
  margin: 5px 0px 0px 8px;
  font-size: 28px;
  color: inherit;
`

export const Subtitle = styled((props) => <TypographyParagraph {...props}/>)`
  width: 100%;
  padding-left: 44px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.79;
  color: ${grey[700]};
`

export const Warning = styled.div`
  width: 100%;
  padding-left: 44px;
  display: flex;
`

export const WarningMessage = styled((props) => <TypographyParagraph {...props}/>)`
  font-size: 14px;
  line-height: 1.79;
  color: ${grey[700]};
`

export const RedCancelIcon = styled((props) => <CancelIcon {...props}/>)`
  color: ${red[400]};
  margin-right: 8px;  
  margin-top: 6.5px;
  font-size: 11px;
`

export const Actions = styled((props) => <DialogActions {...props}/>)`
  padding: 19px 25px 25px 0px;
`

export const ConfirmButton = styled((props) => <Button {...props}/>)`
  color: ${props => props.theme.white};
  background-color: ${red[400]};
  
  &:hover {
    background-color: ${red[700]};
  }

  .MuiButton-label {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: normal;
  }
`

export const CancelButton = styled((props) => <Button {...props}/>)`
  border-color: ${grey[400]};
  color: ${grey[500]};
  margin-left: 16px;
  
  &:hover {
    border-color: ${grey[600]};
    background-color: ${grey[200]};
  }

  .MuiButton-label {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: normal;
  }
`


// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DeleteDebriefDialog/style.js